import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DocumentAttachment } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class DocumentAttachmentService extends TmsWebBaseEditService<DocumentAttachment, DocumentAttachment> {
  constructor() {
    super('DocumentAttachment', $localize`Document Attachment`);
  }

  /** The files attached to one document - one entry per file - in the order they are added to the email. */
  getForDocument(documentId: string): Observable<DocumentAttachment[]> {
    return this.httpService.get<DocumentAttachment[]>(`${this.apiUrl}/GetForDocument/${documentId}`);
  }

  /**
   * Stores a file against the document, for every customer. Which countries get it is set
   * afterwards through `save()`, which the countries modal calls.
   *
   * ⚠️ The server enforces the size limit, not this call - a browser-side check would only be a
   * courtesy. A file over the cap comes back as a 400 with the reason, which the caller shows.
   */
  upload(documentId: string, file: File): Observable<string> {
    const formData = new FormData();
    formData.append('attachment', file);

    return this.httpService.post<string>(`${this.apiUrl}/Upload/${documentId}`, formData);
  }

  /** Removes the file for every country. The blob is deliberately left in place - see the API's Delete. */
  removeAttachment(id: string): Observable<void> {
    return this.httpService.delete<void>(`${this.apiUrl}/${id}`);
  }
}
